// extracted by mini-css-extract-plugin
export var carrierNotice = "_hw-5";
export var carrierNoticePlaceholder = "_hw-6";
export var deliveryRow = "_hw-c";
export var fixedHeight = "_hw-4";
export var freightLogo = "_hw-b";
export var fullWidth = "_hw-3";
export var priceColumn = "_hw-7";
export var radioSelected = "_hw-9";
export var radioUnselected = "_hw-8";
export var selectedOption = "_hw-2";
export var selectedOptionContainer = "_hw-1";
export var selection = "_hw-0";
export var tallSkeletonText = "_hw-a";